/**
 * React Query Client Configuration
 */

import { QueryClient } from '@tanstack/react-query';

export const createQueryClient = () => new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute
      retry: 1,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
    },
    mutations: {
      // Writes (grades, messages, enrollments) are not universally idempotent.
      // A lost response must never silently repeat the instructor's action.
      retry: 0,
    },
  },
});
